<template>
  <div class="notationDetail">
    <ul class="qmNav">
      <li v-for="(item,index) in detailList" :key="index" :class="{'active':activeIndex==index}" @click="turnNav(index)">{{ item }}</li>
    </ul>
    <div class="content">
      <navreplyVue v-if="activeIndex == 0" ref="navreplyVue" />
      <list v-if="isRead && activeIndex == 0" ref="list" :question-id="questionId" :type="type" @openEdit="openEdit" @getPosition="getPosition" />
      <edit v-if="!isRead && activeIndex == 0" ref="edit" :question-id="questionId" :type="type" @startKss="startKss" @openList="openList" />
      <nvalineVue v-if="activeIndex == 1" ref="nvalineVue" :row-data="rowData" />
    </div>
  </div>
</template>

<script>
import list from "./component/list.vue";
import navreplyVue from "./component/navreply.vue";
import nvalineVue from "./component/nvaline.vue";
import edit from "./component/edit.vue";
export default {
  components: { list, navreplyVue, nvalineVue, edit },
  props: ['type', "questionId"],
  data() {
    return {
      detailList: ["内容", "活动"],
      isRead: true,
      activeIndex: 0,
      rowData: ''
    };
  },
  watch: {
    questionId(val) {
      this.init();
    },
    rowData() {
      this.turnNav(0)
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    async turnNav(index) {
      this.activeIndex = index;
      if (index == 0) {
        this.isRead = true;
        const prjId = this.rowData.prjId;
        await this.$nextTick();
        this.$refs.navreplyVue.showCommentInfo(3, prjId, 1, this.questionId, this.questionId, "");
      }
    },
    init() {
      this.activeIndex = 0;
      this.isRead = true;
    },
    // 开启编辑
    openEdit() {
      this.isRead = false;
    },
    getPosition(data){
      this.$emit("getPosition",data);
    },
    // 开启详情
    openList() {
      this.isRead = true;
    },
    startKss(call) {
      this.$emit("startScreenShot", {
        callback: (data) => {
          call.callback(data);
        }
      });
    },
    loadComment() {
      let prjId = this.rowData.prjId;
        let relaId2 = this.questionId;
        let questionId2 = this.questionId;
        this.$nextTick(() => {
          this.$refs.navreplyVue.showCommentInfo(
            3,
            prjId,
            1,
            relaId2,
            questionId2,
            ""
          );
        });
    }
    // startKssDoc(call){
    //   this.$emit("startScreenShot",{
    //     callback:(data)=>{
    //       call.callback(data)
    //     }
    //   })
    // }

  }

};
</script>

<style lang="scss" scoped>
.notationDetail{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .qmNav{
    width: 100%;
    height: 45px;
    padding-top: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 2px solid var(--theme-color);
    li{
      width: 78px;
      height: 100%;
      text-align: center;
      line-height: 35px;
      margin: 0 10px;
      font-size: 15px;
      cursor: pointer;
    }
    li:hover{
      background: #EAEEF8;
      border-radius: 6px 6px 0 0;
      color: var(--theme-color);;
    }
    .active{
      background: var(--theme-color) !important;
      border-radius: 6px 6px 0 0;
      color: #fff !important;
    }
  }
  .content{
    width: 100%;
    // height: calc(100% - 45px);
    .footer{
      width: 100%;
      height: 45px;
    }
  }
}
</style>
